/**
 * Thin, safe wrapper around Google Analytics 4 gtag.js.
 * Silently no-ops if gtag isn't loaded (ad-blocked, offline, test env).
 */
export function trackEvent(eventName, params = {}) {
  try {
    if (typeof window === 'undefined') return;
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', eventName, params);
    // eslint-disable-next-line no-console
    if (process.env.NODE_ENV !== 'production') console.debug('[GA4]', eventName, params);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('[GA4] trackEvent failed', e);
  }
}

/** Fired the moment Claude finishes generating a story successfully. */
export function trackStoryGenerated({ storyId, childName, mythology, deity, language, wordCount, hasSibling } = {}) {
  trackEvent('story_generated', {
    story_id: storyId,
    child_name: childName,
    mythology,
    deity,
    language,
    word_count: wordCount,
    has_sibling: !!hasSibling,
  });
}

/** Fired the moment Dodo (currently mocked) confirms a successful payment. */
export function trackPaymentComplete({ checkoutId, storyId, plan, amount, currency, childName } = {}) {
  trackEvent('payment_complete', {
    checkout_id: checkoutId,
    story_id: storyId,
    plan,
    value: amount,       // GA4 standard `value` field for ecommerce reports
    currency,            // GA4 standard `currency` field
    child_name: childName,
  });
}
